export abstract class PageComponent {
  abstract canGoBack(): boolean;

  isLightPage(): boolean {
    return false;
  }
}
